import React, { useState } from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Table from '../../components/ui/Table';
import { osgChecks, employees, stores } from '../../data/mockData';
import { Download } from 'lucide-react';
import Button from '../../components/ui/Button';
import { useToast } from '../../components/ui/Toast';

export default function OsgChecks() {
  const toast = useToast();
  const [filterResult, setFilterResult] = useState('');

  const enriched = osgChecks.map(c => ({
    ...c,
    employeeName: employees.find(e => e.id === c.employeeId)?.name || c.employeeId,
    storeName: stores.find(s => s.id === c.storeId)?.name || c.storeId,
  }));

  const filtered = filterResult ? enriched.filter(c => c.result === filterResult) : enriched;

  const columns = [
    { key: 'date', label: 'Дата проверки', render: v => <span style={{ fontSize: 12, color: '#6B7280' }}>{new Date(v).toLocaleString('ru-RU')}</span> },
    { key: 'employeeName', label: 'Сотрудник', render: v => <span style={{ fontWeight: 500 }}>{v}</span> },
    { key: 'storeName', label: 'Магазин', render: v => <span style={{ fontSize: 12, color: '#6B7280' }}>{v}</span> },
    {
      key: 'productName', label: 'Товар',
      render: (v, row) => (
        <div>
          <div style={{ fontWeight: 500, fontSize: 13 }}>{v}</div>
          <code style={{ fontSize: 11, color: '#8E8E93' }}>{row.barcode}</code>
        </div>
      )
    },
    { key: 'batchesChecked', label: 'Партий' },
    { key: 'actualQty', label: 'Фактич. кол-во', render: v => <span style={{ fontWeight: 600 }}>{v}</span> },
    { key: 'systemQty', label: 'Системное кол-во', render: v => <span style={{ color: '#6B7280' }}>{v}</span> },
    {
      key: 'discrepancy', label: 'Расхождение',
      render: v => (
        <span style={{ fontWeight: 700, color: v === 0 ? '#34C759' : v < 0 ? '#FF3B30' : '#FF9500' }}>
          {v > 0 ? `+${v}` : v}
        </span>
      )
    },
    {
      key: 'result', label: 'Результат',
      render: v => (
        <Badge variant={v === 'ok' ? 'success' : v === 'expired' ? 'error' : 'warning'}>
          {v === 'ok' ? '✓ Всё ОК' : v === 'expired' ? '✗ Просрочено' : '⚠ Расхождение'}
        </Badge>
      )
    },
  ];

  const stats = {
    ok: osgChecks.filter(c => c.result === 'ok').length,
    discrepancy: osgChecks.filter(c => c.result === 'discrepancy').length,
    expired: osgChecks.filter(c => c.result === 'expired').length,
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: '#1A1A2E' }}>Журнал ОСГ Проверок</h1>
          <p style={{ color: '#8E8E93', fontSize: 13, marginTop: 2 }}>Все проверки сроков годности</p>
        </div>
        <Button variant="secondary" icon={<Download size={14} />} onClick={() => toast('Экспорт CSV', 'success')}>Экспорт</Button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14 }}>
        {[
          { label: 'Без расхождений', count: stats.ok, color: '#34C759', bg: '#F0FFF4' },
          { label: 'Расхождения', count: stats.discrepancy, color: '#FF9500', bg: '#FFF7ED' },
          { label: 'Просроченные', count: stats.expired, color: '#FF3B30', bg: '#FFF0F0' },
        ].map(s => (
          <div key={s.label} style={{ background: s.bg, borderRadius: 12, padding: '16px 20px', textAlign: 'center' }}>
            <div style={{ fontSize: 28, fontWeight: 800, color: s.color }}>{s.count}</div>
            <div style={{ fontSize: 12, color: '#6B7280' }}>{s.label}</div>
          </div>
        ))}
      </div>

      <Card padding="0">
        <div style={{ padding: '14px 20px', borderBottom: '1px solid #F3F4F6', display: 'flex', gap: 8 }}>
          {[
            { key: '', label: 'Все' },
            { key: 'ok', label: '✓ Без расхождений' },
            { key: 'discrepancy', label: '⚠ Расхождения' },
            { key: 'expired', label: '✗ Просроченные' },
          ].map(f => (
            <button key={f.key} onClick={() => setFilterResult(f.key)} style={{
              padding: '6px 14px', borderRadius: 8, border: '1px solid #E5E7EB',
              background: filterResult === f.key ? '#4A6CF7' : '#fff',
              color: filterResult === f.key ? '#fff' : '#6B7280',
              fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
            }}>{f.label}</button>
          ))}
        </div>
        <Table columns={columns} data={filtered} emptyText="Нет проверок" />
      </Card>
    </div>
  );
}
